import type { GarmentOcclusion } from '@seddi/scene';
import type { LoadingManager, WebGLRenderer } from '@seddi/three';
import log from 'loglevel';

import { load } from './garmentOcclusionLoader';
import type { GarmentOcclusionGfx } from './garmentOcclusionTypes';
import { ResourceManager } from './resourceManager';

export class GarmentOcclusionsContext extends ResourceManager<GarmentOcclusionGfx> {
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
  }

  async loadAsync(desc: GarmentOcclusion): Promise<GarmentOcclusionGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`GarmentOcclusionsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc, this.manager, this.renderer);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'GarmentOcclusion');
    }

    return value;
  }
}
